import AtlasIcon from './AtlasIcon';
import './Buttons.css';
import './AtlasLensBar.css';
import { t } from '../../i18n';

// Barra de lentes rápidas do Atlas (fase 2.3 — docs/plans/overhaul-ux-atlas-vivo.md).
// Grupos rápidos = navigation presets (Tudo/Viagens/Rotas/Música/Diário/
// Entretenimento). Isolamento = chips por camada ativa (reusa focusedKey +
// onToggleLens do mesmo estado do mapa). O editor avançado é o FilterDrawer
// completo, que vive no painel "Lentes".
function AtlasLensBar({
  presets = [],
  activePresetKey = null,
  onSelectPreset,
  legendItems = [],
  focusedKey = null,
  onToggleLens,
  onOpenAdvanced,
}) {
  return (
    <div className="av-lensbar" role="toolbar" aria-label={t('web.lens.quick.a11y')}>
      <div className="av-lensbar-group" aria-label="Grupos de lentes">
        {presets.map((preset) => (
          <button
            key={preset.key}
            type="button"
            className={`av-lens-chip${preset.key === activePresetKey ? ' is-active' : ''}`}
            aria-pressed={preset.key === activePresetKey}
            onClick={() => onSelectPreset && onSelectPreset(preset)}
          >
            {preset.label}
          </button>
        ))}
      </div>

      {legendItems.length > 0 && (
        <div className="av-lensbar-group av-lensbar-isolate" aria-label="Isolar camada">
          {legendItems.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`av-lens-dot-chip${item.key === focusedKey ? ' is-focused' : ''}`}
              aria-pressed={item.key === focusedKey}
              title={`Isolar ${item.label}`}
              onClick={() => onToggleLens && onToggleLens(item.key)}
            >
              <span className="av-lens-dot" style={{ backgroundColor: item.color }} />
              {item.label}
            </button>
          ))}
        </div>
      )}

      {onOpenAdvanced && (
        <button
          type="button"
          className="av-btn av-btn--icon av-lens-advanced-btn"
          onClick={onOpenAdvanced}
          title="Editar lentes"
          aria-label={t('web.lens.advanced.a11y')}
        >
          <AtlasIcon name="sliders-horizontal" size={16} />
        </button>
      )}
    </div>
  );
}

export default AtlasLensBar;
